module.exports = __webpack_public_path__ + "static/media/caterer.1e7ad23f.png";